import { Component } from '@angular/core';
//import * as ConnectWise from '../../../assets/js/ConnectWiseHostedAPI.1.0.js';
import * as microsoftTeams from "@microsoft/teams-js";

declare var ConnectWiseHostedAPI: any;

@Component({
  selector: 'app-msteams-test',
  templateUrl: './test.component.html',
})
export class MicrosoftTeamsTestComponent {

  public test: string;

  ngOnInit() {
    this.test = 'set';
    this.initialize();
  }

  ngAfterViewInit() {

  }

  checkAuth() {
    alert('NOW!');
    this.getAuth();
    console.log('test');
  }

  getAuth() {

    microsoftTeams.app.getContext().then((context) => {
      alert(context.user.userPrincipalName);
      alert(context.user.tenant.id);
      microsoftTeams.authentication.getAuthToken().then((result) => {
        //result contains the id token
        alert(result);
      }).catch((err) => {
        alert(err);
      });
    });

  }

  initialize() {

    console.log('start init');
    microsoftTeams.app.initialize();
    console.log('ending init');
  }

  connected(id) {

    this.getAuth();

  }

  onLoad(screen, id) {

    console.log('onLoad');
    console.log(screen);
    console.log(id);

    //connectWiseAuth = screen;

  }

  beforeSave(screen, id, resultCallback) {

  }

  beforeBack() {

  }
}
